import { Box, Container } from "@mui/system";
import background_green from "assets/dynamics-gradient-green.png";
import girlImage from "assets/renee/renee-girls.png";
import productImage from "assets/renee/renee-product.png";
import video from "assets/renee/video1.mp4";
import { usePageView } from "hooks/use-page-view";
import useScrollToTop from "hooks/useScrollToTop";
import { Seo } from "layout/components/Seo";
import { VideoHero } from "layout/components/VideoHero";
import { tokens } from "locales/tokens";
import StorySection from "pages/about/components/StorySection";
import { useTranslation } from "react-i18next";
import ReneeProductComponent from "../components/ReneeProductComponent";

const ReneePage = (props) => {
  const { t } = useTranslation();

  usePageView();
  useScrollToTop();

  return (
    <>
      <Seo />
      <main>
        <VideoHero
          name='renee'
          title={t(tokens.brands.renee.title)}
          description={t(tokens.brands.renee.description)}
          videoSrc={video}
        />
        <Box  sx={{ backgroundColor: { xs: "white", sm: "#E0FFF5" } }}>
          <Container maxWidth="xl">
            <StorySection
              name="renee-story-1"
              backgroundColor={{ xs: "white", sm: "#E0FFF5" }}
              title={t(tokens.brands.renee.whatIs)}
              paragraph={t(tokens.brands.renee.whatIsDescription)}
              backImage={background_green}
              passedImage={productImage}
              hideAction
              paragraphSx={{
                "@media(min-width:768px) and (max-width:991px)": {
                  fontSize: "14px!important"

                }
              }}
            />
          </Container>
        </Box>

        {/* <ReneeProductComponent /> */}

        <Box sx={{
          display: "grid",
          "@media(min-width: 768px) and (max-width: 991px)":

          {
            display: "unset"
          }

        }}>
          <Box sx={{ order: { xs: 2, sm: 1, md: 1 } }}>
            <ReneeProductComponent />
          </Box>

          <Box sx={{ order: { xs: 1, md: 2 }, backgroundColor: { xs: "white", sm: "#E0FFF5" } }} >
            <Container maxWidth="xl" sx={{ padding: { xs: "0!important", md: 5 }, }}>
              <StorySection
                name="renee-story-2"
                backgroundColor={{ xs: "white", sm: "#E0FFF5" }}
                title={t(tokens.brands.renee.keyBenefits)}
                paragraph={
                  <>
                    <ul style={{
                      
                      width: "70%"
                    }}>
                      <li>{t(tokens.brands.renee.keyBenefit1)}</li>
                      <li>{t(tokens.brands.renee.keyBenefit2)}</li>
                      <li>{t(tokens.brands.renee.keyBenefit3)}</li>
                    </ul>
                  </>
                }
                passedImage={girlImage}
                hideAction
                reverse
              />
            </Container>
          </Box>
        </Box>


      </main>
    </>
  );
};

ReneePage.propTypes = {};

export default ReneePage;
